import * as Yup from 'yup';

export const productRetailValidationSchema = Yup.object().shape({
  reason: Yup.string().required().nullable().max(128, 'Reason should be max 128 symbols'),
  retail: Yup.number().required('Retail is required').nullable(),
});

export enum ProductStatus {
  NOT_CONTRACTED = 'NotContracted',
  ERROR = 'Error',
  CONTRACTED = 'Contracted',
}

export enum ProductType {
  COM = 'Com',
  VSC = 'Vsc'
}

export enum Permissions {
  ADMIN = 'Admin',
}

export enum TimeNumber {
  MIN = 60,
  DAYS = 365,
  MONTHS = 12,
  ROUND_VALUE = 100,
}
